// import { LoyaltyRepository, TrainingsGroupRepository } from 'api/repository';
import { DesktopItem, ShowInput } from 'components';
import React, { ReactElement } from 'react';
import './transportDriverLicense.scss';
import { useTranslation } from 'react-i18next';
import { TransportDriverLicenseModel } from 'api/types/Transport';
import useCheckColor from 'store/hooks/useCheckColor';

interface Props {
  userId: number | null;
  dataTransportDriverLicense: TransportDriverLicenseModel[] | null | undefined;
}

const TransportDriverLicense = (props: Props): ReactElement => {
  const { userId, dataTransportDriverLicense } = props;
  const { t } = useTranslation('employee');

  //   START Color

  const checkColor = useCheckColor();

  // END Color

  return (
    <>
      {dataTransportDriverLicense &&
      dataTransportDriverLicense !== null &&
      Object.keys(dataTransportDriverLicense)?.length > 0 ? (
        <div className="userTransportDriverLicenseBox">
          <div className="userTransportDriverLicenseContent">
            {dataTransportDriverLicense?.some(
              (i) =>
                i?.qualification?.categoryName === 'Kategorie' &&
                (i?.qualificationNumber !== null ||
                  i?.qualificationDate !== null ||
                  (i?.expirationQualificationDate !== null &&
                    i?.expirationQualificationDate !== ''))
            ) && (
              <div className="textTransportTitle">
                {t('userTransport.drivingLicenseVehicleCategories')}
              </div>
            )}

            {dataTransportDriverLicense?.some(
              (k) => k.qualificationId === 716
            ) ? (
              <ShowInput
                id="numberTransportDriverLicenseBox"
                label={t('userTransport.numberDrivingLicense')}
                data={
                  dataTransportDriverLicense?.find(
                    (i) => i.qualificationId === 716
                  )?.qualificationNumber
                }
                toLeft
                title
              />
            ) : (
              ''
            )}
            {dataTransportDriverLicense?.some(
              (k) => k.qualificationId === 717
            ) ? (
              <ShowInput
                id="numberTransportDriverLicenseBox"
                label={t('userTransport.numberBlankiet')}
                data={
                  dataTransportDriverLicense?.find(
                    (i) => i.qualificationId === 717
                  )?.qualificationNumber
                }
                toLeft
                title
              />
            ) : (
              ''
            )}
            {dataTransportDriverLicense?.some(
              (k) => k.qualificationId === 717
            ) &&
            dataTransportDriverLicense?.find((i) => i.qualificationId === 717)
              ?.qualificationDate !== null &&
            dataTransportDriverLicense?.find((i) => i.qualificationId === 717)
              ?.qualificationDate !== '' ? (
              <ShowInput
                id="numberTransportDriverLicenseBox"
                label={t('userTransport.qualificationDate')}
                data={
                  dataTransportDriverLicense?.find(
                    (i) => i.qualificationId === 717
                  )?.qualificationDate
                }
                toLeft
                title
              />
            ) : (
              ''
            )}

            <div className="userTransportDriverLicenseContentDetail">
              {Object.keys(dataTransportDriverLicense)?.map((k) => {
                if (
                  dataTransportDriverLicense?.[k]?.qualification.name !==
                    'Numer prawa jazdy' &&
                  dataTransportDriverLicense?.[k]?.qualification.name !==
                    'Numer blankietu' &&
                  dataTransportDriverLicense?.[k]?.qualification
                    ?.categoryName === 'Kategorie'
                ) {
                  return (
                    <DesktopItem
                      id="qualifications"
                      name={
                        dataTransportDriverLicense?.[k]?.qualification
                          ?.description
                      }
                    >
                      <>
                        {dataTransportDriverLicense?.[k]
                          ?.qualificationNumber !== null &&
                        dataTransportDriverLicense?.[k]?.qualificationNumber !==
                          '' &&
                        dataTransportDriverLicense?.[k]?.qualificationNumber !==
                          ' ' ? (
                          <div className="transportDriverLicenseDetailBox">
                            <div className="transportDriverLicenseLabel">
                              {t('userTransport.qualificationNumber')}
                            </div>
                            <div className="transportDriverLicenseValue">
                              {
                                dataTransportDriverLicense?.[k]
                                  ?.qualificationNumber
                              }
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                        {dataTransportDriverLicense?.[k]
                          ?.expirationQualificationDate !== null ? (
                          <div
                            className={`dateTransportDriverLicenseBox ${checkColor(
                              dataTransportDriverLicense?.[k]
                                ?.expirationQualificationDate,
                              'uprawnienia',
                              'prawojazdy'
                            )}`}
                          >
                            <div
                              className={`dateTransportDriverLicenseLabel ${checkColor(
                                dataTransportDriverLicense?.[k]
                                  ?.expirationQualificationDate,
                                'uprawnienia',
                                'prawojazdy'
                              )}`}
                            >
                              {' '}
                              {t('userTransport.expirationQualificationDate')}
                            </div>
                            <div
                              className={`dateTransportDriverLicenseValue ${checkColor(
                                dataTransportDriverLicense?.[k]
                                  ?.expirationQualificationDate,
                                'uprawnienia',
                                'prawojazdy'
                              )}`}
                            >
                              {
                                dataTransportDriverLicense?.[k]
                                  ?.expirationQualificationDate
                              }
                            </div>
                          </div>
                        ) : (
                          ''
                        )}

                        <div className="borderTop" />
                      </>
                    </DesktopItem>
                  );
                }
                return null;
              })}
            </div>
          </div>
          <div className="userTransportDriverLicenseContent">
            {dataTransportDriverLicense?.some(
              (i) =>
                i?.qualification?.categoryName === 'Kategorie - tramwaj' &&
                (i?.qualificationNumber !== null ||
                  i?.qualificationDate !== null ||
                  (i?.expirationQualificationDate !== null &&
                    i?.expirationQualificationDate !== ''))
            ) && (
              <div className="textTransportTitle">
                {t('userTransport.tramCategory')}
              </div>
            )}
            {dataTransportDriverLicense?.some(
              (k) => k.qualificationId === 845
            ) ? (
              <ShowInput
                id="numberTransportDriverLicenseBox"
                label={t('userTransport.numberDrivingLicenseTram')}
                data={
                  dataTransportDriverLicense?.find(
                    (i) => i.qualificationId === 845
                  )?.qualificationNumber
                }
                toLeft
                title
              />
            ) : (
              ''
            )}

            {dataTransportDriverLicense?.some(
              (k) => k.qualificationId === 846
            ) ? (
              <ShowInput
                id="numberTransportDriverLicenseBox"
                label={t('userTransport.numberBlankietTram')}
                data={
                  dataTransportDriverLicense?.find(
                    (i) => i.qualificationId === 846
                  )?.qualificationNumber
                }
                toLeft
                title
              />
            ) : (
              ''
            )}

            {dataTransportDriverLicense?.some(
              (k) => k.qualificationId === 846
            ) &&
            dataTransportDriverLicense?.find((i) => i.qualificationId === 846)
              ?.qualificationDate !== null &&
            dataTransportDriverLicense?.find((i) => i.qualificationId === 846)
              ?.qualificationDate !== '' ? (
              <ShowInput
                id="numberTransportDriverLicenseBox"
                label={t('userTransport.qualificationDateTram')}
                data={
                  dataTransportDriverLicense?.find(
                    (i) => i.qualificationId === 846
                  )?.qualificationDate
                }
                toLeft
                title
              />
            ) : (
              ''
            )}

            <div className="userTransportDriverLicenseContentDetail">
              {Object.keys(dataTransportDriverLicense)?.map((k) => {
                if (
                  dataTransportDriverLicense?.[k]?.qualification.name !==
                    'Numer prawa jazdy - tramwaj' &&
                  dataTransportDriverLicense?.[k]?.qualification.name !==
                    'Numer blankietu - tramwaj' &&
                  dataTransportDriverLicense?.[k]?.qualification
                    ?.categoryName === 'Kategorie - tramwaj'
                ) {
                  return (
                    <DesktopItem
                      id="qualifications"
                      name={
                        dataTransportDriverLicense?.[k]?.qualification
                          ?.description
                      }
                    >
                      <>
                        {dataTransportDriverLicense?.[k]
                          ?.qualificationNumber !== null &&
                        dataTransportDriverLicense?.[k]?.qualificationNumber !==
                          ' ' &&
                        dataTransportDriverLicense?.[k]?.qualificationNumber !==
                          '' ? (
                          <div className="transportDriverLicenseDetailBox">
                            <div className="transportDriverLicenseLabel">
                              {t('userTransport.qualificationNumber')}
                            </div>
                            <div className="transportDriverLicenseValue">
                              {
                                dataTransportDriverLicense?.[k]
                                  ?.qualificationNumber
                              }
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                        {dataTransportDriverLicense?.[k]
                          ?.expirationQualificationDate !== null ? (
                          <div
                            className={`dateTransportDriverLicenseBox ${checkColor(
                              dataTransportDriverLicense?.[k]
                                ?.expirationQualificationDate,
                              'uprawnienia',
                              'prawojazdy'
                            )}`}
                          >
                            <div
                              className={`dateTransportDriverLicenseLabel ${checkColor(
                                dataTransportDriverLicense?.[k]
                                  ?.expirationQualificationDate,
                                'uprawnienia',
                                'prawojazdy'
                              )}`}
                            >
                              {t('userTransport.expirationQualificationDate')}
                            </div>
                            <div
                              className={`dateTransportDriverLicenseValue ${checkColor(
                                dataTransportDriverLicense?.[k]
                                  ?.expirationQualificationDate,
                                'uprawnienia',
                                'prawojazdy'
                              )}`}
                            >
                              {
                                dataTransportDriverLicense?.[k]
                                  ?.expirationQualificationDate
                              }
                            </div>
                          </div>
                        ) : (
                          ''
                        )}

                        <div className="borderTop" />
                      </>
                    </DesktopItem>
                  );
                }
                return null;
              })}
            </div>
          </div>

          <div className="userTransportDriverLicenseContent">
            {dataTransportDriverLicense?.some(
              (i) =>
                i?.qualification?.categoryName === 'Dodatkowe' &&
                (i?.qualificationNumber !== null ||
                  i?.qualificationDate !== null ||
                  (i?.expirationQualificationDate !== null &&
                    i?.expirationQualificationDate !== ''))
            ) && (
              <div className="textTransportTitle">
                {t('userTransport.additional')}
              </div>
            )}

            <div className="userTransportDriverLicenseContentDetail">
              {Object.keys(dataTransportDriverLicense)?.map((k) => {
                if (
                  dataTransportDriverLicense?.[k]?.qualification
                    ?.categoryName === 'Dodatkowe'
                ) {
                  return (
                    <DesktopItem
                      id="qualifications"
                      name={
                        dataTransportDriverLicense?.[k]?.qualification
                          ?.description
                      }
                    >
                      <>
                        {dataTransportDriverLicense?.[k]
                          ?.qualificationNumber !== null &&
                        dataTransportDriverLicense?.[k]?.qualificationNumber !==
                          ' ' &&
                        dataTransportDriverLicense?.[k]?.qualificationNumber !==
                          '' ? (
                          <div className="transportDriverLicenseDetailBox">
                            <div className="transportDriverLicenseLabel">
                              {t('userTransport.qualificationNumber')}
                            </div>
                            <div className="transportDriverLicenseValue">
                              {
                                dataTransportDriverLicense?.[k]
                                  ?.qualificationNumber
                              }
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                        {dataTransportDriverLicense?.[k]
                          ?.expirationQualificationDate !== null ? (
                          <div
                            className={`dateTransportDriverLicenseBox ${checkColor(
                              dataTransportDriverLicense?.[k]
                                ?.expirationQualificationDate,
                              'uprawnienia',
                              'prawojazdy'
                            )}`}
                          >
                            <div
                              className={`dateTransportDriverLicenseLabel ${checkColor(
                                dataTransportDriverLicense?.[k]
                                  ?.expirationQualificationDate,
                                'uprawnienia',
                                'prawojazdy'
                              )}`}
                            >
                              {t('userTransport.expirationQualificationDate')}
                            </div>
                            <div
                              className={`dateTransportDriverLicenseValue ${checkColor(
                                dataTransportDriverLicense?.[k]
                                  ?.expirationQualificationDate,
                                'uprawnienia',
                                'prawojazdy'
                              )}`}
                            >
                              {
                                dataTransportDriverLicense?.[k]
                                  ?.expirationQualificationDate
                              }
                            </div>
                          </div>
                        ) : (
                          ''
                        )}

                        <div className="borderTop" />
                      </>
                    </DesktopItem>
                  );
                }
                return null;
              })}
            </div>
          </div>
          {/* </Box> */}
        </div>
      ) : null}
    </>
  );
};

export default TransportDriverLicense;
